const ITEMS = [
  "FOAM CANNON HAND WASH",
  "INTERIOR DEEP RESTORATION",
  "FULL DETAIL PACKAGES",
  "PET HAIR REMOVAL",
  "STREAK-FREE GLASS",
  "WHEEL & TIRE DEEP CLEAN",
  "ODOR & OZONE TREATMENT",
];

export default function Marquee() {
  return (
    <section aria-hidden data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-[#12141C]/50 py-4">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center">
            {ITEMS.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center font-mono text-xs uppercase tracking-[0.28em] text-slate-500 sm:text-sm">
                <span className="px-8">{item}</span>
                <span className="text-[#FFB703]">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
